import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'site/prefeitos',
		component: Base,
		children: [
			{
				path: '',
				name: 'PrefeitosList',
				component: List,
				meta: {
					path: '/site/prefeitos',
					pai: 'Site',
					title: 'Admin - Prefeitos',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Prefeitos',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'PrefeitosNovo',
				component: Form,
				meta: {
					path: '/site/prefeitos',
					pai: 'Site',
					title: 'Admin - Prefeitos - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Prefeitos',
						class: '',
						active: false,
						url: '/site/prefeitos'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'PrefeitosEditar',
				component: Form,
				meta: {
					path: '/site/prefeitos',
					pai: 'Site',
					title: 'Admin - Prefeitos - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Prefeitos',
						class: '',
						active: false,
						url: '/site/prefeitos'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]